import { motion } from "framer-motion";
import Parallax from "./Parallax";
import CTAButton from "../CTAButton";
import { ASSETS } from "../../data/content";

export default function Act8Ultimatum() {
  return (
    <section data-testid="act-ultimatum" className="relative min-h-[100svh] flex items-center justify-center overflow-hidden bg-[#020202]">
      <Parallax
        src={ASSETS.textureFocus}
        alt=""
        className="absolute inset-0 h-full w-full"
        overlay="bg-[#020202]/90"
        amount={70}
      />
      {/* Vignette */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,transparent_30%,#020202_95%)]" />

      <div className="relative z-10 w-full max-w-[1000px] mx-auto px-6 md:px-12 text-center">
        <motion.span
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1 }}
          className="block font-display text-[10px] tracking-[0.4em] uppercase text-[#D4AF37] mb-10"
        >
          Dentro de un año
        </motion.span>

        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1.1, ease: [0.22, 1, 0.36, 1] }}
          className="font-serif text-white leading-[1.08] tracking-tight text-4xl sm:text-5xl md:text-6xl lg:text-7xl"
        >
          Seguirás teniendo dos opciones.
          <span className="block mt-6 text-white/40">Poner otra excusa.</span>
          <span className="block italic gold-text">
            O empezar a cumplir tu palabra hoy.
          </span>
        </motion.h2>

        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1, delay: 0.35 }}
          className="mt-12 font-display font-light text-white/65 text-base md:text-lg max-w-[48ch] mx-auto leading-relaxed"
        >
          Al dar el paso no entras en un programa. Entras en una comunidad de personas
          que decidieron dejar de empezar de cero y recorren, contigo, el mismo camino.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, delay: 0.5 }}
          className="mt-12 flex justify-center"
        >
          <CTAButton testid="ultimatum-cta" />
        </motion.div>

        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1, delay: 0.8 }}
          className="mt-8 font-serif italic text-white/35 text-lg md:text-xl"
        >
          El mejor momento fue hace un año. El segundo mejor es hoy.
        </motion.p>
      </div>
    </section>
  );
}
